import { Box } from '@mui/material';
import {
  MemoStatefulAutocompleteWithText,
  MemoStatefulMultiselect,
  MemoStatefulPhoneField,
  MemoStatefulSingleSelect,
  MemoStatefulTextField,
} from 'components/dataCreationForms/withInputForm/statefulInputsWrapper';
import React from 'react';
import { UserFieldsPresentationalProps } from './types';
import { inspectionGridSx } from 'components/inspection/layout';

export function UserFieldsPresentational({
  labelFieldProps,
  phoneFieldProps,
  emailFieldProps,
  roleFieldProps,
  sitesFieldProps,
  processesFieldProps,
}: UserFieldsPresentationalProps): React.ReactElement {
  return (
    <Box sx={inspectionGridSx}>
      <Box>
        <MemoStatefulTextField {...emailFieldProps} />
      </Box>
      {labelFieldProps && (
        <Box>
          <MemoStatefulAutocompleteWithText {...labelFieldProps} />
        </Box>
      )}
      {phoneFieldProps && (
        <Box>
          <MemoStatefulPhoneField {...phoneFieldProps} />
        </Box>
      )}
      <Box>
        <MemoStatefulSingleSelect {...roleFieldProps} />
      </Box>
      <Box>
        <MemoStatefulMultiselect {...sitesFieldProps} />
      </Box>
      <Box>
        <MemoStatefulMultiselect {...processesFieldProps} />
      </Box>
    </Box>
  );
}
